import React from 'react';
import { FlexRow, Grid, Header3Text } from 'ui-toolkit';
import { Field, FieldArray, FieldProps } from 'formik';
import { BlockRedirection } from '../../../../cdBuilder/BlockRedirection';
import { CreateEditWireDepositRow } from './CreateEditWireDepositRow';
import { IWireDepositData } from '../../../../../types/order/escrow/IWireDepositData';
import { deleteWireDepositAction } from '../../../../../store/order/escrow/deposits/wireDeposits/deleteWireDepositSlice';
import { HasPermissionButton } from '../../shared/HasPermissionButton';
import { useHasPermissions } from '../../../../accessControl/hooks/useHasPermissions';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import { useAppDispatch } from '../../../../../store/store';

export interface ICreateEditWireDepositsContainerProps {
  dirty: boolean;
  onTransactionUpdate: () => void;
}

export const CreateEditWireDepositsContainer: React.FC<ICreateEditWireDepositsContainerProps> = ({
  dirty,
  onTransactionUpdate,
}) => {
  const dispatch = useAppDispatch();
  const hasEditPermission = useHasPermissions([ePermissions.EscrowExpectedIncomingWiresEdit]);

  const onRemoveWireDeposit = async (wireToRemove: IWireDepositData) => {
    if (wireToRemove.createdAt) {
      dispatch(deleteWireDepositAction(wireToRemove.id));
      onTransactionUpdate();
    }
  };

  return (
    <>
      <BlockRedirection showSaveSpinner={false} showSaveSuccess={false} isDirty={dirty} />
      <FieldArray name={'wireDeposits'}>
        {({ push, remove }) => (
          <>
            <Grid>
              <FlexRow>
                <Header3Text>Wire Deposits</Header3Text>
                <HasPermissionButton
                  hasEditPermission={hasEditPermission}
                  push={push}
                  successMessage={'Add Wire'}
                  transferType={'wire deposits'}
                  defaultObject={{ version: 'v1' }}
                />
              </FlexRow>
              <Field name={'wireDeposits'}>
                {({ field }: FieldProps<IWireDepositData[]>) => (
                  <>
                    {field.value.map((wire, index) => (
                      <CreateEditWireDepositRow
                        key={index}
                        index={index}
                        onDelete={async (index) => {
                          remove(index);
                          await onRemoveWireDeposit(wire);
                        }}
                        fieldName={'wireDeposits'}
                      />
                    ))}
                  </>
                )}
              </Field>
            </Grid>
          </>
        )}
      </FieldArray>
    </>
  );
};
